module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_SL-deeef2147763b347c8959158d3d0cca7.svg";